import { AppRemixIcon } from '@/layout/AppComponents';
import ReactDOMServer from 'react-dom/server';
import colors from '../../../../../../../constants/colors';
import Translator from '../../../../../../components/helpers/Translator';

export default function Actions({ hasActions }) {
  return (
    <span
      title={ReactDOMServer.renderToString(
        <Translator
          file="module-correctiveActions"
          name={
            hasActions
              ? 'has.actions'
              : 'hasnt.actions'
          }
        />
      )}
      $hasActions={hasActions}
    >
      <AppRemixIcon
        icon="file-copy"
        color={hasActions ? colors.primary : colors.grey300}
      />
    </span>
  );
}
